import 'styles/studio.css'

import React from 'react'
import ReactDOM from 'react-dom'
import Main from './app/Main'

ReactDOM.render(<Main/>, document.getElementById('root'))
